import React from "react"
import { Card, CardBody, Col, Row } from "react-bootstrap"
import Skeleton from "react-loading-skeleton"

const Section2Skeleton = () => {
  return (
    <Row>
      <Row className="g-3 mb-3">
        <Col md="6">
          <Row className="g-3">
            <Col md="6">
              <Skeleton height="428px" width="100%" />
            </Col>
            <Col md="6">
              <Skeleton height="428px" width="100%" />
            </Col>
          </Row>
        </Col>
        <Col md="6">
          <Skeleton height="428px" width="100%" />
        </Col>
      </Row>
    </Row>
  )
}

export default Section2Skeleton
